(function () {
    'use strict';
    app.service('LoginService', ['$http', '$q', 'AuthenticationService', '$rootScope', '$cookies',
    function ($http, $q, authenticationService, $rootScope, $cookies) {
        var userInfo;
        var serviceBase = $rootScope.buildConfig.aippsssApiBaseUrl;
        var loginServiceURL = serviceBase + 'token';
        var deviceInfo = [];
        var deferred;

        this.setUserDetail = function (userName) {
            deferred = $q.defer();
            $http.get(serviceBase + "api/Account/user?username=" + userName
                ).then(function (response) {
                    if (response != undefined && response.data.message == undefined) {
                        var expireDate = new Date();
                        expireDate.setDate(expireDate.getDate() + 1);

                        $rootScope.$broadcast('setUserSuccess', { fullName: response.data.eSpectraFirstName + " " + response.data.eSpectraLastName });

                        setLocalValue("premiumType", response.data.isPremiumType);
                        setLocalValue("isAutorenewed", response.data.eSpectraRecurringBillFlag);
                        setLocalValue("maintenanceFlag", response.data.eSpectraByPassMaintFlag);
                        setLocalValue("isPremiumMember", response.data.isPremiumMember)
                        setLocalValue("userRole", response.data.eSpectraUserRole);

                        setLocalValue("fullName", response.data.eSpectraFirstName.concat( " " + response.data.eSpectraLastName));
                        setLocalValue("firstName", response.data.eSpectraFirstName);
                        setLocalValue("emailId", response.data.eSpectraEmail);
                        setLocalValue("affiliationName ", response.data.eSpectraPrimaryAffiliationName);
                        setLocalValue("userRoleStatus", response.data.eSpectraUserRoleStatus); 
                        setLocalValue("isKratosData", response.data.isKratosData); 
                        
                        $rootScope.isSA = getLocalValue("userRole") == 'SAdmin' ? true : false;
                        deferred.resolve(response);
                    }
                })
            .catch(function (err) {
                deferred.resolve(err);
            });

            return deferred.promise;
        }

        this.chekUser = function (emailID) {
            deferred = $q.defer();
            $http.get(serviceBase + "api/Account/user?username=" + emailID).then(function (response) {
                deferred.resolve(response);
            }).catch(function (err) {
                deferred.resolve(err);
            })

            return deferred.promise;
        }

        this.sendResetPasswordCode = function (userName) {

            deferred = $q.defer();

            $http.get(serviceBase + "api/Account/resetpasswordcode?username=" + userName).then(function (response) {


                deferred.resolve(response);
            })
            .catch(function (err) {

                deferred.resolve(err);
            });
            return deferred.promise;
        }
        this.sendemailResetPasswordCodeNotification = function (userRegistrationInfo) {

            deferred = $q.defer();

            $http.get(serviceBase + "api/Account/sendresetpasswordcodenotification?firstName=" + userRegistrationInfo.eSpectraFirstName + "&email=" + userRegistrationInfo.eSpectraEmail + "&status=" + userRegistrationInfo.eSpectraPartyStatus + "&resetCode=" + userRegistrationInfo.eSpectraPasswordResetCode).then(function (response) {


                deferred.resolve(response);
            })
            .catch(function (err) {

                deferred.resolve(err);
            });
            return deferred.promise;
        }



        this.login = function (userName, password) {

            deferred = $q.defer();
            var data = "grant_type=password&username=" + userName + "&password=" + password;
            $http.post(loginServiceURL, data, {
                headers:
                   { 'Content-Type': 'application/x-www-form-urlencoded' }
            }).then(function (response) {
                var o = response;
                userInfo = {
                    accessToken: response.data.access_token,
                    userName: userName,
                    refresh_token: response.data.refresh_token
                };
                authenticationService.setTokenInfo(userInfo);

                setLocalValue("isAuthenticated", "true");
                setLocalValue("userName", userName);
                setLocalValue("userRole", response.data.UserRole);
                setLocalValue("premiumType", response.data.premiumType);
                setLocalValue("isPremiumMember", JSON.parse(response.data.isPremiumMember))
                setLocalValue("isAutorenewed", response.data.isAutorenewed);
                setLocalValue("maintenanceFlag", response.data.maintenanceFlag);
                setLocalValue("isKratosData", response.data.kratosDataAccess);
                $rootScope.hasSharedWorkspaces = response.data.hasSharedWorkspaces;
                $rootScope.isFirstLogin = response.data.isFirstLogin;
                if ($cookies.get('appCookie') == undefined || $cookies.get('appCookie') == null || $cookies.get('appCookie') == '') {
                    $rootScope.$broadcast('setFooter', {});
                }
                $rootScope.$broadcast('loginSuccess', { userName: userName });
                deferred.resolve(null);
            })
            .catch(function (err) {

                deferred.resolve(err.data);
            });
            return deferred.promise;
        }

        this.refreshToken = function () {
            deferred = $q.defer();
            var token = $cookies.get('_rtInf');
            var data = "grant_type=refresh_token&refresh_token=" + token + "&client_id=";

            $http.post(loginServiceURL, data, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                }
            }).then(function (response) {
                var o = response.data;
                var userInfo = {
                    accessToken: o.access_token,
                    refresh_token: o.refresh_token
                };
                authenticationService.setTokenInfo(userInfo);
                
                setLocalValue("isAuthenticated", "true");
                setLocalValue("userRole", response.data.UserRole);
                setLocalValue("premiumType", response.data.premiumType);
                setLocalValue("isPremiumMember", JSON.parse(response.data.isPremiumMember))
                setLocalValue("isAutorenewed", response.data.isAutorenewed);
                setLocalValue("maintenanceFlag", response.data.maintenanceFlag);
                $rootScope.hasSharedWorkspaces = response.data.hasSharedWorkspaces;
                $rootScope.isFirstLogin = response.data.isFirstLogin;

                deferred.resolve(null);
            }).catch(function (err, status) {
                deferred.resolve(err);
            });
            return deferred.promise;
        }

        this.logOut = function () {
            authenticationService.removeToken();
            $rootScope.$broadcast('logoutSuccess', 'true');
        }

        this.getInstituteName = function () {
            $http.get(serviceBase + "api/Account/IPFilter").then(function (response) {
                if (response.status == "204") {
                    $rootScope.$broadcast('getInstituteFail', { error: 'Error' });
                }
                else if (response.data != undefined) {
                    var expireDate = new Date();
                    expireDate.setDate(expireDate.getDate() + 1);
                    $cookies.put("institute", response.data.institute, { expires: expireDate });
                    $rootScope.$broadcast('getInstituteSuccess', { institute: response.data.institute, username: response.data.username, password: response.data.password });
                }
            }, function (err, status) {
                $rootScope.$broadcast('getInstituteFail', { error: 'Error' });
            });
        }

        this.register = function (userRegistrationInfo) {
            deferred = $q.defer();

            $http.post(serviceBase + "api/Account/Register", userRegistrationInfo, {
            }).then(function (response) {
                deferred.resolve(response);
            })
            .catch(function (err, status) {
                deferred.resolve(err);
            });
            return deferred.promise;
        }
        //get country list...


        this.getcountryData = function () {
            deferred = $q.defer();

            $http.get(serviceBase + "country")
            .then(function (response) {
                deferred.resolve(response);
            })
            .catch(function (err) {
                deferred.resolve(err);
            });

            return deferred.promise;
        }
        this.sendRegistrationNotification = function (userRegistrationInfo) {
            deferred = $q.defer();

            $http.post(serviceBase + "api/Account/sendRegistrationNotification", userRegistrationInfo, {
            }).then(function (response) {
                deferred.resolve(response);
            })
            .catch(function (err, status) {
                deferred.resolve(err);
            });
            return deferred.promise;
        }


        this.verifyRegistration = function (userId) {

            deferred = $q.defer();

            $http.post(serviceBase + "api/Account/VerifyRegistration/" + userId)
            .then(function (response) {

                deferred.resolve(response);

            })
            .catch(function (err) {

                deferred.resolve(err);
            });
            return deferred.promise;
        }

        this.resetPassword = function (resetPasswordInfo) {
            deferred = $q.defer();
            $http.post(serviceBase + "api/Account/resetPassword", resetPasswordInfo, {
            }).then(function (response) {
                deferred.resolve(response);
            })
            .catch(function (err, status) {
                deferred.resolve(err);
            });
            return deferred.promise;
        }

        this.Invite = function (memberList, firstName, inviterFirstName, inviterLastName) {

            deferred = $q.defer();
            $http.post(serviceBase + "api/Account/InviteMember?members=" + memberList.join() + "&firstName=" + firstName + "&inviterFirstName=" + inviterFirstName + "&inviterLastName=" + inviterLastName)
            .then(function (response) {
                deferred.resolve(response);
            })
            .catch(function (err, status) {
                deferred.resolve(err);
            });
            return deferred.promise;
        }

        this.getInstitutions = function () {
            deferred = $q.defer();
            $http.get(serviceBase + "api/Account/institutions", {
            }).then(function (response) {
                deferred.resolve(response);
            })
            .catch(function (err, status) {
                deferred.resolve(null);
            });
            return deferred.promise;
        }

        this.saveExtraInfo = function (data) {
            deferred = $q.defer();
            $http.post(serviceBase + "api/Account/saveextrainfo", data, {
            }).then(function (response) {
                deferred.resolve(null);
            })
            .catch(function (err, status) {
                deferred.resolve(err);
            });
            return deferred.promise;
        }

        this.getGlobalValues = function () {
            deferred = $q.defer();
            $http.get(serviceBase + "globalValues")
            .then(function (response) {
                deferred.resolve(response);
            })
            return deferred.promise;
        }

        this.createInternalUser = function (data) {
            deferred = $q.defer();
            $http.post(serviceBase + "api/Account/internalRegistration", data, {
            }).then(function (response) {
                deferred.resolve(response);
            })
            .catch(function (err, status) {
                deferred.resolve(err);
            });
            return deferred.promise;
        }

        this.createInstitutionAccount = function (data) {
            deferred = $q.defer();
            $http.post(serviceBase + "api/super/institutionAccount", data, {
            }).then(function (response) {
                deferred.resolve(response);
            })
            .catch(function (err, status) {
                deferred.resolve(err);
            });
            return deferred.promise;
        }

        this.sendInternaldRegistrationNotification = function (userRegistrationInfo) {
            deferred = $q.defer();

            $http.post(serviceBase + "api/Account/sendinternalregistrationnotification", userRegistrationInfo, {
            }).then(function (response) {
                deferred.resolve(response);
            })
            .catch(function (err, status) {
                deferred.resolve(err);
            });
            return deferred.promise;
        }
        this.sendConfirmationToUserDelete = function (userEmail,userFirstname) {
            deferred = $q.defer();

            $http.post(serviceBase + "api/Account/sendConfirmationToUserDelete?email=" + userEmail + "&firstname=" + userFirstname)
               .then(function (response) {
                   deferred.resolve(response);
               })
            .catch(function (err, status) {
                deferred.resolve(err);
            });
            return deferred.promise;
        }
    }
    ]);
})();